export const originPath = window.location.origin;